import { ReactElement } from "react";
import ReactDom from "react-dom";

const TooltipPortal = ({ children }: { children: ReactElement }) => {
  const el = document.getElementById("tooltip-root");

  if (el) return ReactDom.createPortal(children, el);
  else return children;
};

export default TooltipPortal;
